<form [formGroup]="formGroup" dgxFormSubmit *ngIf="formGroup">
  <dgx-form-fieldset legend="Billing address" [legendDisplayAsLabel]="true">
    <dgx-form-row [formGroup]="formGroup">
      <dgx-form-field class="address-checkbox" formControlName="toggled">
        <dgx-form-checkbox [label]="'Same as delivery address'">
        </dgx-form-checkbox>
        <span
          class="label typog-body-bold"
          (click)="showAddress = !showAddress"
        >
          <i class="fa-solid fa-eye"></i>
          <span class="link typog-body-bold">{{
            showAddress ? 'Hide address' : 'Show address'
          }}</span>
        </span>
      </dgx-form-field>

      <div *ngIf="cardPaymentRedirect?.request?.billingAddress as address">
        <address *ngIf="showAddress" [dgxQmSanitise]="'block'" [@slideInOut]>
          <p>{{ address.addressLine1 }}</p>
          <p>{{ address.addressLine2 }}</p>
          <p>{{ address.addressLine3 }}</p>
          <p>{{ address.addressLine4 }}</p>
          <p>{{ address.postalCode }}</p>
        </address>
      </div>

      <div
        *ngIf="!toggledValue && !addressChanged"
        class="address-form"
        [@slideInOut]
      >
        <p>
          Please provide your billing address before continuing to payment
          details.
        </p>

        <br />

        <dgx-form-address formGroupName="address"></dgx-form-address>
        <div class="cta">
          <dgx-form-submit-button
            class="mt-4"
            (click)="changeAddress(formGroup)"
          >
            Confirm address
          </dgx-form-submit-button>
        </div>
      </div>
    </dgx-form-row>
  </dgx-form-fieldset>
</form>

<app-worldpay
  *ngIf="(cardPaymentRedirect && toggledValue) || addressChanged"
  [cardPaymentRedirect]="cardPaymentRedirect?.response"
></app-worldpay>
